<template>
  <div class="home">
    <div class="container">
      <h1>《样品检测委托协议》</h1>
      <h2>一、通用条款：</h2>
      <p>总则：在中科名兽医APP或小程序下单检测时适用于本协议下述各条款</p>
      <p>1.除非特别指定，北京中科基因技术股份有限公司（下简称“乙方”）对检测试验有完全判断权，其中包括检测试验方法的选择以及使用最新版本的检测试验方法来完成检测。如甲方未指定或未填写检测试验方法，则视为同意乙方实验室所选择的检测试验方法。</p>
      <p>2.甲方应对所提供的样品信息及实物的真实性负责。对由于甲方提供不清楚、不正确、不完全、误导或虚假信息导致的任何不正确结果及产生损失的由甲方自行承担全部责任，乙方不承担任何责任。同时鉴于乙方的试验投入有权向甲方要求适当赔偿。如有有毒有害、放射性、爆炸性或易传染等样品，应事先告知乙方，如未如实告知导致乙方或任何第三方损失的，甲方全额赔偿相关损失。</p>
      <p>3.乙方对本《样品检测委托协议》有修改权。鉴于检测试验的即时性，乙方不会另行通知甲方对协议内容的修改，双方之间的协议内容，以甲方下单时文本为准。甲方在中科名兽医APP或小程序委托检测下单时需要认真阅读协议内容，对协议内容无异议后再提交当次检测订单。</p>
      <p>4.付款方式：先付款再检测。甲方在中科名兽医APP或小程序下单同步支付当次检测费用或下单后银行对公转账，经乙方确认检测费到账后安排检测。同时按到账金额给甲方开具正规合法发票。付款为委托检测的生效要件，如甲方未支付检测费，双方的委托协议不生效，乙方不予提供检测服务。</p>
      <p>5.本《样品检测委托协议》中所指的接收日为工作日。从乙方接收到甲方在中科名兽医APP或小程序下单、提供合格样品且付款的后的下一个工作日起算，不包括周末及国家法定节假日；当日15：00点（含）以后的生效订单、样品均视为下一个工作日为接收日。某些检测试验根据试验程序可能需要更长的时间，乙方业务代表将以电话或微信的形式会与甲方进一步确认。</p>
      <p>6.甲方委托送检样品，经乙方确认样品数量和样品质量无误后，于72小时内出具抗体检测报告，48小时内出具核酸检测报告，一周内出具细菌分离与药敏试验检测报告。如遇公休日或法定节假日时间自动顺延。若一次送检样品超过日常检测承载量，出具检测报告时间双方另行约定。</p>
      <p>7.结合实际检测情况，经甲方邮件或微信等形式确认后乙方可以将全部或部分检测项目委派给第三方。</p>
      <p>8.乙方出具的检测报告仅对甲方当次送检样品的检测项目负责，检测结果仅反映送检样品所检测项目的评价，不反映对被抽取样品的同批产品的评价。</p>
      <p>9.乙方对检测结果按标准判定为可疑样品的默认不复检，如甲方要求复检可疑样品，或是对检验结论有异议的，应在收到检测报告之日起15日内（含）书面形式提出复检（乙方只进行一次复检），逾期不予受理。如甲方在上述时间内提出复检要求的，仅限对符合检测要求的留样样品进行复检。可疑样品的复检，须另行支付复检费用；有异议样品的复检，如复检结果维持原检验结论的，须支付复检费用。对于以下情况，乙方不受理复检：①原样品已用完或原样品剩余太少不足以复检的；②原样品已被甲方取回的；③原样品超过保存期限或已变质的；④微生物检测等不可重复测试的项目；⑤收到检测报告已超过15日的。</p>
      <p>10.甲方不得将检测报告及相关数据进行非法活动、不得用于商业广告，不得私自涂改、变造报告形式和内容。对由上述行为而造成的一切后果乙方均不负任何法律责任，并保留追究甲方责任的权利。如发生对检测报告的不正当使用，乙方保留收回检测报告的权利。</p>
      <p>11.如在检测过程中发生人力不可抗拒的事故，如战争、火灾、台风、地震或双方认可的事故如仪器故障所造成的样品损坏、检测终止等，双方将重新商讨检测事宜。</p>
      <p>12.乙方存档的检测报告、原始数据及样品资料信息原则上将被保存6年（以报告签发日期始计），6年之后如甲方未提出要求的，存档的检测报告、原始数据及样品资料信息将由乙方自行销毁。检测样品留样的最长保存期为甲方收到检测报告后15日（含）。</p>
      <p>13.双方对对方信息及在实施实验室活动过程中获得或产生的所有信息负有保密义务。</p>
      <p>14.以上条款法律法规有另行规定的，以相关法律法规规定为准。</p>
      <h2>二、测试标准/方法确认条款：</h2>
      <p>1.乙方首先采取国家标准检验方法进行检测。如甲方要求全部或部分按其他国家或地区的标准/方法及相关法规进行测试的，甲方应提供真实、全面、完整、清晰的相关信息，并另提供一份盖章或签字的委托协议，并在委托协议上注明为“采用委托人指定的标准、方法或方案”，乙方不承担相关责任。</p>
      <p>2.如甲方未提出指定标准/方法进行测试的，则视为认可使用乙方提供的标准/方法进行测试。</p>
      <p>3.乙方提供的测试标准/方法包括但不限于国际和国内先进测试技术标准、科学研究进展、法律法规规定以及本行业最新实验室验证技术（非标准方法），在客户服务合同评审过程中由甲方自行选择。</p>
      <p>4.依据农业农村部或其他政府部门要求规定，在乙方所检测的样品中若出现必须上报的重大动物疫病，乙方将依据相关规定将结果上报至相关政府机构。</p>
      <h2>三、违约责任：</h2>
      <p>1.甲方在中科名兽医APP或小程序下单并提交本次订单前，应完整阅读本协议。提交订单并付款后视为甲方已仔细阅读并同意遵守上述各项条款，《样品委托检测协议》即生效。</p>
      <p>2.若违反上述协议，造成守约方或第三方损失的，由违约方承担全部赔偿责任。</p>
      <p class="address">生效日期： 2021年06月02日</p>
    </div>
  </div>
</template>

<script>
// import { shopCombination } from '@/api/resetApi.js'

export default {
  name: 'announcement',
  data(){
    return{
      tiem: '',
      timer: '',
      goodsList: [],
    }
  },
  created(){
  },
  methods: {
  }
}
</script>

<style lang="scss">
.home {
  max-width: 780px;
  margin: 0 auto;
}
.container {
  padding: 20px 10px;
  h1 {
    text-align: center;
    font-size: 16px;
    padding-bottom: 10px;
  }
  h2 {
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    padding-bottom: 5px;
  }
  h3 {
    padding: 5px 0;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
  }
  p {
    padding-bottom: 10px;
    text-align: left;
    line-height: 20px;
    font-size: 12px;
    color: #000;
  }
  strong {
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    color: #000;
  }
  .address-p {
    padding-bottom: 0;
  }
  .address {
    padding: 10px;
    text-align: right;
  }
}
</style>
